export default {
    title: 'ចែករំលែកប្រព័ន្ធផ្ទុក',
    shared_hosting: 'ចែករំលែកប្រព័ន្ធផ្ទុក',
    invoice_id: 'លេខសម្គាល់វិក្ក័យប័ត្រ',
    reg_date: 'កាលបរិច្ឆេទចុះឈ្មោះ',
    due_date: 'កាលបរិច្ឆេទ​ផុត​កំណត់',
    server_status: 'ស្ថានភាពម៉ាស៊ីនមេ',
    status: 'ស្ថានភាព',
    package: 'កញ្ចប់',
    server_name: 'ឈ្មោះម៉ាស៊ីនមេ',
    name_server: 'ឈ្មោះម៉ាស៊ីនមេ',
    username: 'ឈ្មោះ​អ្នកប្រើប្រាស់',
    shared_hosting_detail: 'ចែករំលែកព័ត៌មានលំអិតនៃប្រព័ន្ធផ្ទុក',
    shared_hosting_info: 'ចែករំលែកព័ត៌មានប្រព័ន្ធផ្ទុក',
    cpanel: 'ផ្ទាំង cPanel',
    action: 'សកម្មភាព',
    domain: 'ដែន',
    shared_hosting_extend: 'ពង្រីកចែករំលែកប្រព័ន្ធផ្ទុក',
    shared_hosting_package: 'កញ្ចប់ចែករំលែកប្រព័ន្ធផ្ទុក',
    payment_plan: 'កម្រោងទូទាត់',
    update_domain: 'ការផ្លាស់ប្តូរឈ្មោះdomainចម្បងរបស់អ្នក',
    new_main_domain_name: 'ឈ្មោះdomainសំខាន់ថ្មី',
    new_main_domain_name_placeholder: 'សូមបញ្ចូលឈ្មោះdomainថ្មីរបស់អ្នក',
    new_main_domain_name_warning: {
        title: 'សំខាន់! តើការផ្លាស់ប្តូរនេះមានន័យយ៉ាងណា',
        text_1: {
            title: 'ស្ទួនឈ្មោះ Domain',
            content:
                'ឈ្មោះdomainសំខាន់ថ្មីរបស់អ្នកមិនគួរមាននៅក្នុងគណនីបង្ហោះចែករំលែក 1Byte ផ្សេងទៀតទេ',
        },
        text_2: {
            title: 'ការធ្វើការ updates ដោយស្វ័យប្រវត្តិ',
            content:
                'មាតិកា/ឯកសារណាមួយ អ៊ីមែល និងគណនី FTP នឹងត្រូវបានចាត់តាំងឡើងវិញពីឈ្មោះdomainពីមុនរបស់អ្នកទៅកាន់គណនីថ្មីមួយរបស់អ្នក',
        },
        text_3: {
            title: 'តម្រូវឱ្យធ្វើការ updates ដោយដៃ',
            content:
                'រាល់ឯកសារយោងមូលដ្ឋានទិន្នន័យ URL ទំនាក់ទំនង និងបញ្ជីសំបុត្ររួម វិញ្ញាបនបត្រ SSL ។ ទោះជាយ៉ាងណាក៏ដោយ ការដំឡើងកម្មវិធី Softaculous និងការបម្រុងទុករបស់ពួកគេនឹងមិនត្រូវបានចាត់តាំងឡើងវិញពីឈ្មោះdomainពីមុនរបស់អ្នកទៅឈ្មោះថ្មីរបស់អ្នកទេ។ ពួកគេគួរតែត្រូវបានធ្វើការ update ដោយដៃ',
        },
    },
    new_main_domain_error:
        'វាហាក់ដូចជាឈ្មោះdomainនេះត្រូវបានហាមឃាត់ មានរួចហើយ ឬមានពាណិជ្ជសញ្ញា',
    understand_and_agree: 'ខ្ញុំយល់និងយល់ព្រម',
    auto_renew: 'បន្តដោយស្វ័យប្រវត្តិ',
    upgrade_shared_hosting: 'បង្កើនទំហំ Shared Hosting',
    upgrade_warning:
        'អ្នក ត្រូវ បង់ ប្រាក់ បញ្ជា ទិញ នេះ ក្នុង មួយ ថ្ងៃ បើ មិន ដូច្នេះ ទេ ការ បញ្ជា ទិញ នឹង ត្រូវ បាន លុប',
    package_name: 'មោះកញ្ចប់',
    change_password: 'ប្តូរពាក្យសម្ងាត់របស់ Shared Hosting',
};
